import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { Label, RadioGroup, RadioGroupItem } from '@cold-ambulance/shadcn';

export function YesNoField({
  className,
  label,
  onValueChange,
  value,
}: PropsWithChildren<{
  label?: string;
  className?: string;
  value?: string;
  onValueChange?: (value: string) => void;
}>) {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <Label className="mb-4">{label}</Label>
      <RadioGroup
        value={value}
        onValueChange={onValueChange}
        className="flex"
        dir="rtl"
      >
        <div className="flex h-11 w-full items-center gap-3 rounded-lg border px-4">
          <RadioGroupItem value={'true'} id="r1" />
          <Label htmlFor="r1">{t('common.yes')}</Label>
        </div>
        <div className="flex h-11 w-full items-center gap-3 rounded-lg border px-4">
          <RadioGroupItem value={'false'} id="r2" />
          <Label htmlFor="r2">{t('common.no')}</Label>
        </div>
      </RadioGroup>
    </div>
  );
}
